import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit, OnChanges {

  @Input() startDate:Date;
  @Input() endDate:Date;
  @Input() tableData: string[] = [];
  groupedData: { userName: string }[][] = [];
  formattedStartDate: string;
  formattedEndDate: string;
  loader:boolean=true;
  formatDate(date: Date): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  ngOnInit() {
    if(this.tableData){
    this.groupedData = this.groupData(this.tableData);}
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData']?.currentValue) {
      this.groupedData = this.groupData(this.tableData);
      this.formattedStartDate = this.formatDate(this.startDate);
      this.formattedEndDate = this.formatDate(this.endDate);
    }
  }


  groupData(data: string[]): { userName: string }[][] {
    const parsedData = data.map(item => {
        const name = item.split(':')[0].trim();
        return { userName: name };
    });

    const groupInterval = Math.ceil(parsedData.length / 2);
    const grouped: { userName: string }[][] = [];

    for (let i = 0; i < groupInterval; i++) {
        const first = parsedData[i];
        const second = parsedData[i + groupInterval] || null;

        if (second) {
            grouped.push([first, second]);
        } else {
            grouped.push([first]);
        }
    }
    this.loader=false
    return grouped;
}

}

